import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

import backIcon from '../../assets/backspace-icon.png';
import './ReportManager.css';

function ReportManager({ user }) {
  const [reports, setReports] = useState([]);
  const [typeFilter, setTypeFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const res = await api.get('/reports/admin');
        setReports(res.data.reports || []);
      } catch (err) {
        console.error('❌ Failed to fetch reports:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchReports();
  }, []);

  const filtered = reports.filter((r) =>
    typeFilter === 'all' ? true : r.reportedType === typeFilter
  );

  return (
    <div className="reportmanager-container">
      <div className="reportmanager-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="reportmanager-back-icon"
          onClick={() => navigate('/admin')}
        />
        <h2>Reported Content</h2>
      </div>

      <div className="reportmanager-scroll-area">
        <div className="reportmanager-content">
          <div className="reportmanager-filters">
            <button onClick={() => setTypeFilter('all')} className={typeFilter === 'all' ? 'active' : ''}>All</button>
            <button onClick={() => setTypeFilter('post')} className={typeFilter === 'post' ? 'active' : ''}>Posts</button>
            <button onClick={() => setTypeFilter('product')} className={typeFilter === 'product' ? 'active' : ''}>Products</button>
          </div>

          {loading ? (
            <p className="loading-text">Loading reports...</p>
          ) : filtered.length === 0 ? (
            <p className="empty-text">✅ No reports found for this filter.</p>
          ) : (
            filtered.map((r) => (
              <div key={r._id} className="report-card" onClick={() => navigate(`/admin/reports/${r._id}`)}>
                <p><strong>Type:</strong> {r.reportedType}</p>
                <p><strong>Reason:</strong> {r.reason}</p>
                <p><strong>Reporter:</strong> {r.reporterUsername}</p>
                <p><strong>Date:</strong> {new Date(r.createdAt).toLocaleString()}</p>
                <p><strong>Total reports:</strong> {r.totalReports || 1}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default ReportManager;
